import styled from "styled-components";

export const ProgressStyled = styled.div<{ stepCount: number }>`
	display: flex;
	align-items: center;
	justify-content: ${(props) => (props.stepCount < 5 ? "center" : "normal")};
	transform: ${(props) =>
		(props.stepCount < 5 && "translateX(-2em)") || "translateX(0)"};

	&.page-variant {
		margin-top: 4.7em;

		&.event-completed {
			margin-top: 2em;
		}
	}

	&.portrait {
		transform: ${(props) =>
			(props.stepCount === 7 && "rotate(-90deg) translate(-34em, -94%)") ||
			(props.stepCount === 6 && "rotate(-90deg) translate(-27em, -70%)") ||
			(props.stepCount === 4 && "rotate(-90deg) translate(-17em, -22%)") ||
			(props.stepCount === 3 && "rotate(-90deg) translate(-11em, 0%)") ||
			"rotate(-90deg) translate(-22em, -50%)"};
		&.page-variant {
			margin-top: 6.5em;

			&.event-completed {
				margin-top: 2em;
			}
		}
	}
`;
